export default {
  REFILL: 'Refill',
  FIRST_FILL: 'First Fill',
};
